// @flow

import EventEmitter from 'events';
import * as StateActionTypes from 'action_types/StateActionTypes';
import Dispatcher from 'dispatcher';
import _ from 'lodash';
import State from 'models/State';

const CHANGE = 'change';

let _states = {};

class StateStore extends EventEmitter {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }
  
  getStates = () => {
    return _.values(_states);
  };
  
  getStateById = (id: string) => {
    return _states[id];
  };

  getFirstElement = () => {
    return _.values(_states)[0];
  }

  getSize = ():boolean => {
    return Object.keys(_states).length;
  }
  
  addChangeListener = (callback: () => void) => {
    this.on(CHANGE, callback);
  };
  
  removeChangeListener = (callback: () => void) => {
    this.removeListener(CHANGE, callback);
  };
  
  _setStates = (states: State[]) => {
    _states = {};
    _.forEach(states, (state) => {
      _states[state.id] = state;
    });
  };
  
  _emitChange = () => {
    this.emit(CHANGE);
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case StateActionTypes.LIST_STATES: {
        this._setStates(action.states);
        this._emitChange();
        break;
      }
    }
  };
}

export default new StateStore();
